import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSavedSizeApplied.meta';

export type UseTrackSavedSizeAppliedParams = {
  source: 'canvas_picker' | 'crop';
  size_preset_id: string;
};

export const useTrackSavedSizeApplied = () => {
  const { track } = useAnalyticsUtilities();

  const trackSavedSizeApplied = useCallback(
    (params: UseTrackSavedSizeAppliedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSavedSizeApplied };
};
